import { render, staticRenderFns } from "./SectionReasonTwo.vue?vue&type=template&id=0918cbb8&scoped=true&"
import script from "./SectionReasonTwo.vue?vue&type=script&lang=js&"
export * from "./SectionReasonTwo.vue?vue&type=script&lang=js&"
import style0 from "./SectionReasonTwo.vue?vue&type=style&index=0&id=0918cbb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918cbb8",
  null
  
)

export default component.exports